export default "__VITE_ASSET__C0Lx7gd___"